<template>

  <div>
    <div class="alert_text"  >
       <img class="warning-icon" src="../assets/icons/warning.svg"/>
       <p>Page not found</p>
       <p>Try heading to the <router-link :to="{ name: 'home'}">homepage</router-link></p>
    </div>
  </div>
   
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {

      };
  },
  created:function(){

    
  },
  computed:{
   
  },
  methods:{

     

  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/variables";


.alert_text{
  margin-top: calc(50vh - 96px);
  width:100%;
  display:block;
  text-align: center;
  .warning-icon{
    display:block;
    margin-bottom:10px;
    margin:0 auto;
  }
  p, a{
    text-align: center;
    color:white !important;
  }
 
}

</style>
